import { mapState, mapActions } from 'vuex'
import { random } from 'lodash-es'
import { captureException } from '@sentry/browser'

import { EventBus } from '@/utils/event-bus'

export default {
  computed: {
    ...mapState([ 'previewChange', 'loading', 'shopObj' ]),
    hasPendingChanges: function () {
      return Object.values(this.previewChange).some(v => !!v)
    },
    routeReady: function () {
      return !this.loading && this.routeReady_ && this.shopObj
    }
  },
  data: function () {
    return {
      routeReady_: false
    }
  },
  beforeMount: function () {
    this.routeReady_ = false
    this.delayTheRoute(this.$router.currentRoute)
  },
  beforeRouteLeave: function (to, from, next) {
    this.handleNavigation(to, from, next)
  },
  beforeRouteUpdate: function (to, from, next) {
    this.handleNavigation(to, from, next)
  },
  methods: {
    ...mapActions([ 'getClient' ]),
    handleNavigation: function (to, from, next) {
      if (this.hasPendingChanges && !from.path.startsWith('/setup')) {
        EventBus.$once('pendingchange:action', action => {
          if (action === 'stay') return next(false)

          this.checkForLoading({ to, from, next })
        })

        EventBus.$emit('pendingchange:show')
      } else {
        this.checkForLoading({ to, from, next })
      }
    },
    checkForLoading: function ({ to, from, next }) {
      this.routeReady_ = false

      if (['/amp', '/home'].find(path => to.path.startsWith(path))) {
        this.getClient()
      }

      if ((to.name && from.name) && (to.name === from.name)) {
        this.continueTheRoute(to)
      } else {
        this.delayTheRoute(to)
      }

      next()
    },
    continueTheRoute: function (to) {
      try {
        const suffix = 'Superchargify Dashboard'
        const arr = to.matched.filter(r => !!r.meta.title).map(r => r.meta.title).reverse()
        const title = arr.join(' - ')

        if (title) {
          document.title = `${title} | ${suffix}`
        } else {
          document.title = suffix
        }
      } catch (e) {
        captureException(e)
      }

      this.routeReady_ = true
    },
    delayTheRoute: function (to) {
      if (to.name === 'setup_done') {
        this.continueTheRoute(to)
        return
      }

      setTimeout(() => {
        this.continueTheRoute(to)
      }, random(200, 300))
    }
  }
}
